import { render } from "./TermsAndConditions.vue?vue&type=template&id=2a1e5be4&scoped=true"
const script = {}

import "./TermsAndConditions.vue?vue&type=style&index=0&id=2a1e5be4&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1e5be4"]])

export default __exports__